import React, { useEffect, useMemo, useState } from "react";

export default function BajasMarkdownLike({
  url = "https://sandbox.sagec.subtel.gob.cl/service/admin/bajas_grouped/?fecha_desde=2025-01-01",
}) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error("HTTP " + res.status + ": " + res.statusText);
        const json = await res.json();
        if (!Array.isArray(json)) throw new Error("La API no devolvió un arreglo");
        if (!alive) return;
        setData(json);
      } catch (e) {
        if (!alive) return;
        setError((e && e.message) || "Error al cargar");
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [url]);

  // ordenar por mes_orden asc y operador asc
  const ordenada = useMemo(() => {
    if (!data) return [];
    return data.slice().sort((a, b) => {
      const am = String(a.mes_orden || "");
      const bm = String(b.mes_orden || "");
      if (am === bm) return String(a.operador || "").localeCompare(String(b.operador || ""));
      return am.localeCompare(bm);
    });
  }, [data]);

  // agrupar por mes (mes_orden para orden estable)
  const gruposPorMes = useMemo(() => {
    const map = new Map(); // key: mes_orden -> { mes, items: [grupos operador] }
    for (const g of ordenada) {
      const key = String(g.mes_orden || g.mes || "");
      if (!map.has(key)) map.set(key, { mes: g.mes, items: [] });
      map.get(key).items.push(g);
    }
    return Array.from(map.entries()).map(([mesOrden, payload]) => ({
      mesOrden,
      mes: payload.mes,
      items: payload.items,
    }));
  }, [ordenada]);

  if (loading) return <pre style={styles.info}>Cargando...</pre>;
  if (error) return <pre style={{ ...styles.info, color: "crimson" }}>Error: {error}</pre>;
  if (!gruposPorMes.length) return <pre style={styles.info}>(Sin resultados)</pre>;

  return (
    <div style={styles.wrap}>
      <h1>Bajas por Mes y Operador</h1>

      {gruposPorMes.map(({ mesOrden, mes, items }, idxMes) => (
        <div key={mesOrden}>
          <h2>{mes}</h2>

          {items.map((g, idxOp) => (
            <div key={mesOrden + "_" + idxOp} style={{ marginBottom: 16 }}>
              <p>
                <strong>Operador:</strong> {g.operador}
                <br />
                <strong>Total Bajas:</strong> {g.total_bajas}
              </p>

              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>RBD</th>
                    <th style={styles.th}>Fecha Baja</th>
                  </tr>
                </thead>
                <tbody>
                  {(g.rbds || []).map((r, i) => (
                    <tr key={r.rbd + "_" + i}>
                      <td style={styles.td}>{r.rbd}</td>
                      <td style={styles.td}>{r.fecha_baja}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}

          {idxMes < gruposPorMes.length - 1 && <hr style={styles.hr} />}
        </div>
      ))}
    </div>
  );
}

const styles = {
  wrap: { padding: 12, maxWidth: 980, margin: "0 auto" },
  table: { width: "100%", borderCollapse: "collapse", marginTop: 8 },
  th: { border: "1px solid #ccc", padding: "8px", background: "#f2f2f2", textAlign: "left" },
  td: { border: "1px solid #ccc", padding: "8px", textAlign: "left", verticalAlign: "top" },
  hr: { margin: "24px 0", border: 0, borderTop: "1px solid #ddd" },
  info: {
    margin: 0,
    padding: "8px",
    whiteSpace: "pre-wrap",
    borderRadius: 6,
    background: "#f7f7f7",
    border: "1px dashed #ddd",
    fontFamily:
      "ui-monospace, Menlo, Monaco, Consolas, 'Courier New', monospace",
    fontSize: 12,
  },
};

